// extracted by mini-css-extract-plugin
export default {"column":"SurveyContactRelations_column__zFmBc"};